import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-drawer-workorder-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './drawer-workorder-title.component.html',
  styleUrls: ['./drawer-workorder-title.component.scss'],
})
export class DrawerWorkorderTitleComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) externalId!: string | null | undefined;
  @Input({ required: true }) clientName!: string | null | undefined;
}
